(function () {
  var root = document.querySelector('[data-rmenu]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rmc]'));
  var filterInputs = Array.prototype.slice.call(root.querySelectorAll('[data-rmenu-filter]'));
  var clearBtn = root.querySelector('[data-rmenu-clear]');

  // "Gluten" and "Shellfish" are the filter's own labels, but products are
  // actually tagged "Wheat" and "Crustaceans" instead — unlike every other
  // allergen filter, these two words share no substring with their product
  // data at all, so they need an explicit link rather than relying on the
  // two-way substring check below.
  var ALLERGEN_SYNONYMS = {
    gluten: ['wheat'],
    shellfish: ['crustaceans']
  };

  function activeValues(type) {
    return filterInputs
      .filter(function (el) { return el.dataset.rmenuFilter === type && el.checked; })
      .map(function (el) { return el.value; });
  }

  // Portion Size (Standard / Plus) — a single-select radio group, always
  // active (unlike diet/allergen, there's always exactly one portion
  // selected), matched against each card's own data-portion (set in
  // reset-menu-card.liquid from whether the product's title contains
  // "Plus"). Defaults to "standard" if nothing's checked for some reason.
  var portionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-rmenu-portion]'));
  function selectedPortion() {
    var checked = portionInputs.filter(function (el) { return el.checked; })[0];
    return checked ? checked.value : 'all';
  }

  // Which delivery day (Sunday/Wednesday) is currently selected in the
  // delivery-day picker (owned by reset-delivery-calendar.js — this only
  // reads its state, via the same .is-active class it sets, rather than
  // duplicating that logic). Defaults to "sun" to match that script's own
  // default selection on page load.
  function selectedDeliveryDay() {
    var activeBtn = root.querySelector('[data-rdel-day].is-active');
    return activeBtn ? activeBtn.dataset.rdelDay : 'sun';
  }

  // The exact real calendar date those Sunday/Wednesday buttons actually
  // mean right now (reset-delivery-calendar.js exposes this — same source,
  // not a separate guess) — e.g. "2026-09-27", not just the abstract label
  // "sun". This is what a card's own day-position tags get checked against,
  // so a match is only ever real: an actual date range on the product that
  // genuinely contains this exact date, at the right day-of-week position —
  // never a different week that happens to also be tagged "day1-3" or
  // "day4-6" for some unrelated date.
  function selectedRealDate(day) {
    var dates = window.ResetDeliveryDates;
    return dates ? dates[day] : null;
  }

  // Plain "start~end~day" entries separated by "|" (see reset-menu.liquid /
  // reset-menu-card.liquid) — deliberately not JSON. An earlier attempt at
  // hand-building a JSON string in Liquid via string concatenation came out
  // with literal backslashes baked into the value itself by the time it
  // reached the page, breaking JSON.parse for every card at once (confirmed
  // with temporary on-page debug output). This format has no quotes or
  // other special characters for anything to mangle in the first place.
  function parseDayTags(raw) {
    if (!raw) return [];
    return raw.split('|').filter(Boolean).map(function (entry) {
      var parts = entry.split('~');
      // "cycle~min~max" — a Goal Plan swap-alternate tag, restricted to one
      // delivery half-week cycle (1-3 = Sunday batch, 4-6 = Wednesday batch)
      // with no specific week or exact date attached at all. Distinct from
      // the exact-date entries below, which cardMatchesDay() tells apart by
      // this literal 'cycle' marker.
      if (parts[0] === 'cycle') {
        return { cycle: true, minDay: parseInt(parts[1], 10), maxDay: parseInt(parts[2], 10) };
      }
      return { start: parts[0], end: parts[1], day: parseInt(parts[2], 10) };
    });
  }

  // start-to-end date-range tags use the Mon-Sun convention (start = day1's
  // own Monday date) — so a tag's own "real Sunday/Wednesday order date" is
  // a FIXED offset from its start, not "any date somewhere in this week":
  // day1-3 (the Sunday batch, Mon-Wed) is ordered on the Sunday right
  // *before* day1 (start - 1 day); day4-6 (the Wednesday batch, Thu-Sat) is
  // ordered on day3's own Wednesday (start + 2 days), delivering the
  // following Thu-Sat of that same week. Confirmed live as a real bug: the
  // old check only tested whether the selected real date fell *anywhere*
  // within [start, end] — inclusive of both ends — which let it match a
  // week whose actual order date had already passed (today past the
  // Sunday/Wednesday this week's tags actually belong to, but still inside
  // the raw start–end span), showing dishes for an order window that's no
  // longer open at all.
  function addDaysToIso(iso, delta) {
    var parts = iso.split('-').map(function (n) { return parseInt(n, 10); });
    var d = new Date(parts[0], parts[1] - 1, parts[2]);
    d.setDate(d.getDate() + delta);
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  // A card with real day-position tags only matches a delivery day when one
  // of its own tags is for that exact bucket (1-3 for Sunday, 4-6 for
  // Wednesday) AND that tag's own real order date (computed above) is
  // exactly the currently selected real Sunday/Wednesday date — not just
  // "sometime in the same week". A card with no day-tags at all (evergreen)
  // always matches, regardless of which day is selected.
  function cardMatchesDay(card, day) {
    var tags = parseDayTags(card.dataset.dayTags);
    if (!tags.length) return true;

    var minDay = day === 'sun' ? 1 : 4;
    var maxDay = day === 'sun' ? 3 : 6;

    // Cycle tags (Goal Plan swap alternates) need no date at all — just
    // "does this product's tagged cycle match the selected delivery day".
    // Checked first since it's independent of window.ResetDeliveryDates.
    var matchesCycleTag = tags.some(function (t) {
      return t.cycle && t.minDay === minDay && t.maxDay === maxDay;
    });
    if (matchesCycleTag) return true;

    var dateTags = tags.filter(function (t) { return !t.cycle; });
    // Had only cycle tags, and none matched this delivery cycle — a real
    // Sunday-only (or Wednesday-only) swap alternate, correctly hidden on
    // the other day, not evergreen.
    if (!dateTags.length) return false;

    var realDate = selectedRealDate(day);
    if (!realDate) return true; // dates not ready yet — don't hide everything over it

    var offset = day === 'sun' ? -1 : 2;
    return dateTags.some(function (t) {
      return t.day >= minDay && t.day <= maxDay && realDate === addDaysToIso(t.start, offset);
    });
  }

  function applyFilters() {
    var allergens = activeValues('allergen');
    var diets = activeValues('diet');
    var portion = selectedPortion();
    var anyActive = allergens.length > 0 || diets.length > 0 || portion !== 'all';
    var day = selectedDeliveryDay();

    if (anyActive) {
      root.setAttribute('data-has-active-filters', '');
      if (filtersPanel) filtersPanel.setAttribute('data-has-active-filters', '');
    } else {
      root.removeAttribute('data-has-active-filters');
      if (filtersPanel) filtersPanel.removeAttribute('data-has-active-filters');
    }

    cards.forEach(function (card) {
      var cardAllergens = (card.dataset.allergens || '').split('|').filter(Boolean);

      // Exact equality here used to silently match nothing: the filter's own
      // option words (e.g. "Egg", "Soy", from the theme editor's freeform
      // "Allergen filter options" list) don't literally match the product
      // data's own wording (e.g. "eggs", "soybeans") word-for-word, even
      // though they clearly mean the same allergen — confirmed against a
      // real product export. A two-way substring check catches that (either
      // word containing the other) without needing a hardcoded synonym list
      // for most of them — except these two, where the product data's own
      // wording doesn't share any substring with the filter label at all
      // ("wheat" vs "gluten", "crustaceans" vs "shellfish"), so checking the
      // filter word's synonym too is what actually links them.
      var matchesAllergen = allergens.length === 0 || !allergens.some(function (a) {
        var words = ALLERGEN_SYNONYMS[a] ? [a].concat(ALLERGEN_SYNONYMS[a]) : [a];
        return cardAllergens.some(function (ca) {
          return words.some(function (w) { return ca.indexOf(w) !== -1 || w.indexOf(ca) !== -1; });
        });
      });
      // Opposite sense from allergens on purpose: checking a diet/nutrition
      // box means "show me only meals that have this," not "hide meals
      // that have this" — so it's a match if the card has ANY of the
      // selected diets, not none of them.
      var cardDiets = (card.dataset.diets || '').split('|').filter(Boolean);
      var matchesDiet = diets.length === 0 || diets.some(function (d) {
        return cardDiets.some(function (cd) { return cd.indexOf(d) !== -1 || d.indexOf(cd) !== -1; });
      });
      var matchesPortion = portion === 'all' || (card.dataset.portion || 'standard') === portion;
      var matchesDay = cardMatchesDay(card, day);

      var visible = matchesAllergen && matchesDiet && matchesPortion && matchesDay;
      card.classList.toggle('is-filtered-out', !visible);
    });

    root.querySelectorAll('[data-rmenu-category]').forEach(function (section) {
      var totalCards = section.querySelectorAll('[data-rmc]').length;
      var visibleCards = section.querySelectorAll('[data-rmc]:not(.is-filtered-out)');
      // A category with real products (like Breakfast) that just don't
      // happen to match the current day/portion/allergen filter used to
      // have its whole section — banner included — hidden outright here.
      // That looked exactly like the category had vanished/broken (it's
      // what was being reported), especially since a page reload briefly
      // shows it filter-less before this runs. Instead, the section itself
      // always stays put; only a plain "no matches" message toggles inside
      // it, same spot a genuinely-empty category already used server-side.
      var isFilteredEmpty = totalCards > 0 && visibleCards.length === 0;
      var msg = section.querySelector('[data-rmenu-filtered-empty]');
      if (isFilteredEmpty) {
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'rmenu__empty-category';
          msg.setAttribute('data-rmenu-filtered-empty', '');
          msg.textContent = 'No meals match your current filters in this category.';
          section.appendChild(msg);
        }
        msg.hidden = false;
      } else if (msg) {
        msg.hidden = true;
      }
    });
  }

  // Puts a dish's Standard and Plus card right next to each other in the
  // grid — they're two separate products (different titles, different
  // variant), so the collection's own natural order has no reason to keep
  // them adjacent. Only matters visually when both are actually visible at
  // once (the "All" portion option) — when a specific portion is selected
  // the other one of the pair is hidden anyway, so this just runs
  // unconditionally once up front rather than re-running per filter change;
  // a reorder that happens to sit behind a hidden card has no visible
  // effect either way. data-rmc-base is each card's title with the exact
  // " - Plus" suffix stripped (set in reset-menu-card.liquid), so the
  // Standard and Plus version of the same dish share the same key.
  function groupPlusVariants() {
    root.querySelectorAll('[data-rmenu-category] .rmenu__grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-rmc]'));
      var byBase = {};
      items.forEach(function (card) {
        var base = card.dataset.rmcBase || '';
        if (!base) return;
        (byBase[base] = byBase[base] || []).push(card);
      });
      Object.keys(byBase).forEach(function (base) {
        var group = byBase[base];
        if (group.length < 2) return;
        group.sort(function (a, b) {
          return (a.dataset.portion === 'plus' ? 1 : 0) - (b.dataset.portion === 'plus' ? 1 : 0);
        });
        for (var i = 1; i < group.length; i++) {
          group[i - 1].after(group[i]);
        }
      });
    });
  }
  groupPlusVariants();

  filterInputs.forEach(function (el) {
    el.addEventListener('change', applyFilters);
  });
  portionInputs.forEach(function (el) {
    el.addEventListener('change', applyFilters);
  });

  root.querySelectorAll('[data-rdel-day]').forEach(function (btn) {
    btn.addEventListener('click', applyFilters);
  });
  applyFilters();

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      filterInputs.forEach(function (el) { el.checked = false; });
      // Portion Size always has exactly one selection — "clear" resets it
      // back to the default (All) rather than leaving nothing checked.
      portionInputs.forEach(function (el) { el.checked = el.value === 'all'; });
      applyFilters();
    });
  }

  // sidebar jump links — smooth scroll + active-state highlight on scroll
  var jumpLinks = Array.prototype.slice.call(root.querySelectorAll('[data-rmenu-jump]'));
  var categories = Array.prototype.slice.call(root.querySelectorAll('[data-rmenu-category]'));

  jumpLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.dataset.target;
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      closeFiltersDrawer();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // mobile-only "Filters" drawer toggle — no-op on desktop since the
  // toggle button is hidden there via CSS, so these listeners just never fire
  var filtersToggle = root.querySelector('[data-rmenu-filters-toggle]');
  var filtersClose = root.querySelector('[data-rmenu-filters-close]');
  var filtersPanel = root.querySelector('[data-rmenu-filters-panel]');
  var filtersBackdrop = root.querySelector('[data-rmenu-filters-backdrop]');

  // The theme's section wrappers can establish a CSS containing block
  // (via transform/contain, used for scroll-driven entrance animations),
  // which silently breaks `position: fixed` on any descendant — it ends up
  // confined to that wrapper's box instead of the real viewport. Relocating the
  // toggle/backdrop/panel to be direct children of <body> sidesteps that.
  // MOBILE ONLY: on desktop these three stay put inside .rmenu__sidebar,
  // because the panel relies on `display: contents` there so its contents
  // (category nav, filters) render as normal in-flow sidebar items — moving
  // it out of the sidebar on desktop would break that layout entirely.
  var sidebarHost = filtersToggle ? filtersToggle.parentNode : null;
  var isDrawerRelocated = false;
  var mobileDrawerQuery = window.matchMedia('(max-width: 990px)');

  function syncDrawerPlacement() {
    if (!filtersPanel || !filtersBackdrop || !sidebarHost) return;
    var shouldBeInBody = mobileDrawerQuery.matches;
    if (shouldBeInBody && !isDrawerRelocated) {
      var themeVars = ['--rmenu-bg', '--rmenu-ink', '--rmenu-card', '--rmenu-accent', '--rmenu-line', '--rmenu-muted'];
      var computed = getComputedStyle(root);
      themeVars.forEach(function (name) {
        filtersPanel.style.setProperty(name, computed.getPropertyValue(name));
        if (filtersToggle) filtersToggle.style.setProperty(name, computed.getPropertyValue(name));
      });
      document.body.appendChild(filtersBackdrop);
      document.body.appendChild(filtersPanel);
      if (filtersToggle) document.body.appendChild(filtersToggle);
      isDrawerRelocated = true;
    } else if (!shouldBeInBody && isDrawerRelocated) {
      closeFiltersDrawer();
      sidebarHost.appendChild(filtersToggle);
      sidebarHost.appendChild(filtersBackdrop);
      sidebarHost.appendChild(filtersPanel);
      isDrawerRelocated = false;
    }
  }

  function openFiltersDrawer() {
    if (filtersPanel) filtersPanel.setAttribute('data-open', '');
    if (filtersBackdrop) filtersBackdrop.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeFiltersDrawer() {
    if (filtersPanel) filtersPanel.removeAttribute('data-open');
    if (filtersBackdrop) filtersBackdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
  }

  syncDrawerPlacement();
  if (mobileDrawerQuery.addEventListener) {
    mobileDrawerQuery.addEventListener('change', syncDrawerPlacement);
  } else if (mobileDrawerQuery.addListener) {
    mobileDrawerQuery.addListener(syncDrawerPlacement);
  }

  // Delivery-day box: rendered once, inside the sidebar markup — on desktop
  // it's real-DOM-moved into the main content column instead (an anchor
  // element reset-menu.liquid renders at the top of .rmenu__content for
  // exactly this), same "move it, don't duplicate it" approach as the
  // filters drawer above, and reusing that same breakpoint. Mobile is left
  // completely alone — it already shows the daybox directly in the sidebar's
  // own row layout, which is what's wanted there.
  var daybox = root.querySelector('[data-rmenu-daybox-desktop]');
  var dayboxSidebarHost = daybox ? daybox.parentNode : null;
  var dayboxAnchor = root.querySelector('[data-rmenu-daybox-anchor]');
  var isDayboxRelocated = false;

  function syncDayboxPlacement() {
    if (!daybox || !dayboxAnchor || !dayboxSidebarHost) return;
    var shouldBeInContent = !mobileDrawerQuery.matches;
    if (shouldBeInContent && !isDayboxRelocated) {
      dayboxAnchor.parentNode.insertBefore(daybox, dayboxAnchor);
      isDayboxRelocated = true;
    } else if (!shouldBeInContent && isDayboxRelocated) {
      dayboxSidebarHost.insertBefore(daybox, dayboxSidebarHost.firstChild);
      isDayboxRelocated = false;
    }
  }

  syncDayboxPlacement();
  if (mobileDrawerQuery.addEventListener) {
    mobileDrawerQuery.addEventListener('change', syncDayboxPlacement);
  } else if (mobileDrawerQuery.addListener) {
    mobileDrawerQuery.addListener(syncDayboxPlacement);
  }

  if (filtersToggle) filtersToggle.addEventListener('click', openFiltersDrawer);
  if (filtersClose) filtersClose.addEventListener('click', closeFiltersDrawer);
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFiltersDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFiltersDrawer();
  });

  if ('IntersectionObserver' in window && categories.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = root.querySelector('[data-target="' + entry.target.id + '"]');
          if (!link) return;
          if (entry.isIntersecting) {
            jumpLinks.forEach(function (l) { l.classList.remove('is-active'); });
            link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    categories.forEach(function (section) { observer.observe(section); });
  }
})();
